import styled from "@emotion/styled";

export const MessagesStyles = styled("div")`
  position: relative;
  display: flex;
  flex-direction: column;

  height: 100%;
  justify-content: flex-end;

  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .messages {
    &__wrap {
      overflow: auto;
      margin-bottom: 18px;
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    }
  }
`;
